module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/full.75b2ce11e6652e76ad0d.jpg";